<template>
  <Toast />
  <ConfirmDialog />
  <router-view />
</template>

<script setup lang="ts">
import { useTitle } from './composables/useTitle';
import { useToast } from 'primevue/usetoast';
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';
import { onMounted } from 'vue';
import { setToastInstance } from './api/httpClient';

// Initialize title management
useTitle();

// Initialize toast service
const toast = useToast();

// Set toast instance in httpClient
onMounted(() => {
  setToastInstance(toast);
});
</script>
